import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/eyeFilled.svg';

export const IconEyeFilled = createIconComponent(Icon);
